// styles
import * as S from './SoldOutCheckAvailability.styles';

const SoldOutCheckAvailability = ({handlOpenCalendar = () => {}}) => {
  const handleOnClick = () => {
    handlOpenCalendar();
  };
  return (
    <S.SoldOutWrapper>
      <S.SoldOutDescWrapper>
        <span>Add date of travel to check availability:</span>
        <S.Button onClick={handleOnClick}>Check Availability</S.Button>
      </S.SoldOutDescWrapper>
    </S.SoldOutWrapper>
  );
};

export default SoldOutCheckAvailability;
